import { render } from "./noticeCreate.vue?vue&type=template&id=2f77edd6&scoped=true"
import script from "./noticeCreate.vue?vue&type=script&lang=js"
export * from "./noticeCreate.vue?vue&type=script&lang=js"

import "./noticeCreate.vue?vue&type=style&index=0&id=2f77edd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f77edd6"]])

export default __exports__